"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLawNum = exports.lawNumLikeToLawNum = exports.ptnLawNumLike = exports.ptnLawNumArabic = exports.ptnLawNum = void 0;
const num_1 = require("./num");
const std_1 = require("./std");
exports.ptnLawNum = "(?:\
(?<era>明治|大正|昭和|平成|令和)(?<year>[一二三四五六七八九十]+|元)年\
(?:\
(?:\
(?<type1>[^ 　\t\r\n<>()（）[\\]［］{}｛｝「」]+?)\
(?:第(?<num1>[〇一二三四五六七八九十百千]+)号)\
)\
|\
(?:\
(?<type2>人事院規則)\
(?<num2>[―〇一二三四五六七八九]+)\
)\
|\
(?:\
([一二三四五六七八九十]+)月([一二三四五六七八九十]+)日\
(?<type3>内閣総理大臣決定)\
)\
|\
(?:\
(?<type4>憲法|勅令|内務省・鉄道省令|逓信省・鉄道省令|逓信省・農林省令|農林省・大蔵省・内務省令(?:第(?<num3>〇)号)?)\
)\
)\
)";
exports.ptnLawNumArabic = "(?:\
(?<a_era>明治|大正|昭和|平成|令和)(?<a_year>[0123456789０１２３４５６７８９]+)年\
(?:\
(?:\
(?<a_type1>[^ 　\t\r\n<>()（）[\\]［］{}｛｝「」]+?)\
(?:第(?<a_num1>[0123456789０１２３４５６７８９]+)号)\
)\
|\
(?:\
(?<a_type2>人事院規則)\
(?<a_num2>[―0123456789０１２３４５６７８９]+)\
)\
|\
(?:\
([0123456789０１２３４５６７８９]+)月([0123456789０１２３４５６７８９]+)日\
(?<a_type3>内閣総理大臣決定)\
)\
|\
(?:\
(?<a_type4>憲法|勅令|内務省・鉄道省令|逓信省・鉄道省令|逓信省・農林省令|農林省・大蔵省・内務省令(?:第(?<a_num3>[0０])号))\
)\
)\
)";
exports.ptnLawNumLike = `(?:\
(?:${exports.ptnLawNum})\
|\
(?:日本国憲法)\
|\
(?:${exports.ptnLawNumArabic})\
)`;
const reLawNumArabic = new RegExp(`^${exports.ptnLawNumArabic}$`);
const lawNumLikeToLawNum = (lawNum) => {
    if (/日本国憲法$/.test(lawNum)) {
        return "昭和二十一年憲法";
    }
    else if (reLawNumArabic.test(lawNum)) {
        return lawNum.replace(/[0123456789０１２３４５６７８９]+/g, digits => (0, num_1.digitsToKanjiNum)(digits, "non-positional"));
    }
    else {
        return lawNum;
    }
};
exports.lawNumLikeToLawNum = lawNumLikeToLawNum;
const lawTypes = [
    [/^(?:憲法)$/, "Constitution"],
    [/^(?:法律)$/, "Act"],
    [/^(?:政令|太政官布告|太政官達|太政官布達)$/, "CabinetOrder"],
    [/^(?:勅令)$/, "ImperialOrder"],
    [/^(?:海上保安庁令)$/, "Rule"],
    [/^(?:\S+令)$/, "MinisterialOrdinance"],
    [/^\S*(?:中央労働委員会規則|公正取引委員会規則|電波監理委員会規則|公安審査委員会規則|国家公安委員会規則|国家公安委員会規程|公害等調整委員会規則|運輸安全委員会規則|原子力規制委員会規則|特定個人情報保護委員会規則|個人情報保護委員会規則|カジノ管理委員会規則)$/, "MinisterialOrdinance"],
    [/^(?:\S+規則)$/, "Rule"],
    [/^(?:内閣総理大臣決定)$/, "Rule"],
];
const getLawtype = (text) => {
    for (const [re, type] of lawTypes) {
        if (re.exec(text))
            return type;
    }
    return null;
};
const reLawNum = new RegExp(`^${exports.ptnLawNum}$`);
const parseLawNum = (lawNum) => {
    const ret = {
        Era: null,
        Year: null,
        LawType: null,
        Num: null,
    };
    const m = lawNum.match(reLawNum);
    if (m) {
        const { era, year, type1, type2, type3, type4, num1, num2, num3 } = m.groups ?? {};
        const type = [
            type1 ?? "",
            type2 ?? "",
            type3 ?? "",
            type4 ?? "",
        ].join("");
        const num = [
            num1 ?? "",
            num2 ?? "",
            num3 ?? "",
        ].join("");
        if (era in std_1.eras)
            ret.Era = std_1.eras[era];
        ret.Year = (0, num_1.parseKanjiNum)(year);
        ret.LawType = getLawtype(type);
        ret.Num = (0, num_1.parseNamedNum)(num) || null;
    }
    return ret;
};
exports.parseLawNum = parseLawNum;
//# sourceMappingURL=lawNum.js.map